import { surveyServices } from '../services';
import { surveyConstants,configConstants } from '../constants';
import { loader, alert as customAlert } from 'helpers';
import { change } from 'redux-form';
import i18n from 'i18n';
import lodash from 'lodash';

const defaultFailedText = 'api_messages.SOMETHING_WENT_WRONG';

export const surveyAction = {

    fetchSurveyList,
    addSurvey,
    addSubSurvey,
    getSurveyLists,
    getSubSurveyLists,
    getSurveyById,
    getSubSurveyById,
    updateSurvey,
    updateSubSurvey,
    deleteSubSurvey,
    getCompleteSurveyLists,
};



function fetchSurveyList() {
    return dispatch => {
        loader(dispatch, true)
        //earnSpecialsServices.addEarnSpecials(params)
        surveyServices.fetchSurveyList()
            .then(
                response => {
                    if (response.status) {
                        // dispatch({
                            
                        //     type: surveyConstants.SURVEY_LIST,
                        //     data: response.data
                        // });
                        dispatch(success(response.data));
                        //customAlert(dispatch, 'success', i18n.t('warning_messages.campaign_was_created'));
                    } else {                   
                            if (!response.unAlert) {
                                let responseMessage = response.message.toString()
                                if (responseMessage.includes('_')) {
                                    customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
                                } else {
                                    customAlert(dispatch, 'error', response.message.toString())
                                }
                            }
                        // }
                    }
                },
                error => {
                    customAlert(dispatch, 'error', i18n.t(defaultFailedText))
                }
            // ).then(() => {
            //     loader(dispatch, true)
            // })
            ).finally(() => {
                loader(dispatch, false);
            });
    };
    function success(tmp) { return { type: surveyConstants.SURVEY_LIST, data: tmp } }
}


function addSurvey(params) {
    return dispatch => {
        loader(dispatch, true)
        //earnSpecialsServices.addEarnSpecials(params)
        surveyServices.addSurvey(params)
            .then(
                response => {
                    if (response.status) {
                        //console.log("addSurvey",response.data);
                        let addSurveyData = response.data
                        addSurveyData._idSurvey = addSurveyData._id
                        //console.log("addSurveyData",addSurveyData);
                        let formInitialValues = addSurveyData

                        dispatch({
                            //type: earnSpecialsConstants.ADD_EARN_SPECIALS_SUCCESS
                            type: surveyConstants.ADD_SURVEY,
                            data: formInitialValues,
                        });
                        dispatch(surveyAction.getSurveyById(addSurveyData._id))
                        customAlert(dispatch, 'success', i18n.t('warning_messages.campaign_was_created'));
                    } else {                   
                            if (!response.unAlert) {
                                let responseMessage = response.message.toString()
                                if (responseMessage.includes('_')) {
                                    customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
                                } else {
                                    customAlert(dispatch, 'error', response.message.toString())
                                }
                            }
                        // }
                    }
                },
                error => {
                    customAlert(dispatch, 'error', i18n.t(defaultFailedText))
                }
            ).then(() => {
                loader(dispatch, false)
            })
    };
}

function addSubSurvey(params) {
    let initialValues = {

        //surveyId: surveyId,

        questionType: "", 
        question: "",
        questionOrder: "",
        numberAnswer: "",
        numberSelectAnswer: "",
        status_subsurvey: "",

        answer1: "",
        answer2: "",
        answer3: "",
        answer4: "",
        answer5: "",
        answer6: "",
        answer7: "",
        answer8: "",
        answer9: "",
        answer10: "",
        answer11: "",
        answer12: "",
        answer13: "",
        answer14: "",
        answer15: "",
        givePoint1: "",
        givePoint2: "",
        givePoint3: "",
        givePoint4: "",
        givePoint5: "",
        givePoint6: "",
        givePoint7: "",
        givePoint8: "",
        givePoint9: "",
        givePoint10: "",
        givePoint11: "",
        givePoint12: "",
        givePoint13: "",
        givePoint14: "",
        givePoint15: "",

  }

    return dispatch => {
        loader(dispatch, true)
        //earnSpecialsServices.addEarnSpecials(params)
        surveyServices.addSubSurvey(params)
            .then(
                response => {
                    if (response.status) {
                        dispatch({
                            //type: earnSpecialsConstants.ADD_EARN_SPECIALS_SUCCESS
                            type: surveyConstants.ADD_SUB_SURVEY, data: initialValues
                        });
                        customAlert(dispatch, 'success', i18n.t('warning_messages.campaign_was_created'));
                    } else {                   
                            if (!response.unAlert) {
                                let responseMessage = response.message.toString()
                                if (responseMessage.includes('_')) {
                                    customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
                                } else {
                                    customAlert(dispatch, 'error', response.message.toString())
                                }
                            }
                        // }
                    }
                },
                error => {
                    customAlert(dispatch, 'error', i18n.t(defaultFailedText))
                }
            ).then(() => {
                loader(dispatch, false)
            })
    };
}

function getSurveyLists(params) {
    return dispatch => {
        // loader(dispatch, true)
        dispatch({ type: surveyConstants.SHOW_TABLE_LOADER })
        surveyServices.getSurveyLists(params)
            .then(
                response => {
                    try {
                        console.log(response);
                        if (response.status) {
                            console.log("if");
                            dispatch(success(response.data));
                        } else {
                            if(!response.unAlert) customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
                        }
                    } catch (e) {
                        customAlert(dispatch, 'error', i18n.t(defaultFailedText))
                    }
                },
                error => {
                    customAlert(dispatch, 'error', i18n.t(defaultFailedText))
                }
            ).then(() => {
                // loader(dispatch, false)
                dispatch({ type: surveyConstants.HIDE_TABLE_LOADER })
            })
    }
    function success(tmp) { return { type: surveyConstants.GET_SURVEY_DATA_SUCCESS, data: tmp } }
}

function getSubSurveyLists(params) {
    return dispatch => {
         //loader(dispatch, true)
        dispatch({ type: surveyConstants.SHOW_TABLE_LOADER })
        surveyServices.getSubSurveyLists(params)
            .then(
                response => {
                    try {
                        console.log(response);
                        if (response.status) {
                            console.log("if");
                            dispatch(success(response.data));
                        } else {
                            if(!response.unAlert) customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
                        }
                    } catch (e) {
                        customAlert(dispatch, 'error', i18n.t(defaultFailedText))
                    }
                },
                error => {
                    customAlert(dispatch, 'error', i18n.t(defaultFailedText))
                }
            ).then(() => {
                 //loader(dispatch, false)
                dispatch({ type: surveyConstants.HIDE_TABLE_LOADER })
            })
    }
    function success(tmp) { return { type: surveyConstants.GET_SUB_SURVEY_DATA_SUCCESS, data: tmp } }
}

function getCompleteSurveyLists(params) {

    return dispatch => {
        // loader(dispatch, true)
        dispatch({ type: surveyConstants.SHOW_TABLE_LOADER })
        surveyServices.getCompleteSurveyLists(params)
            .then(
                response => {
                    try {
                        console.log(response);
                        if (response.status) {
                            //console.log("if");
                            dispatch(success(response.data,params));
                        } else {
                            if(!response.unAlert) customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
                        }
                    } catch (e) {
                        customAlert(dispatch, 'error', i18n.t(defaultFailedText))
                    }
                },
                error => {
                    customAlert(dispatch, 'error', i18n.t(defaultFailedText))
                }
            ).then(() => {
                // loader(dispatch, false)
                dispatch({ type: surveyConstants.HIDE_TABLE_LOADER })
            })

    }
    function success(tmp,params) { return { type: surveyConstants.GET_COMPLETE_SURVEY_DATA_SUCCESS, data: tmp, params: params } }
}

function getSurveyById(id) {
    return dispatch => {
        loader(dispatch, true)
        surveyServices.getSurveyById(id)
            .then(
                response => {
                    if (response.status) {
                        // let selectedProductList = [];
                        const surveyData = response.data
                        surveyData._idSurvey = surveyData._id;
                        let formInitialValues = surveyData   

                        console.log("surveyData:",surveyData) 
                        
                        //const baseURL = process.env.REACT_APP_BACKEND_CRM_BASE_URL.replace('/api/v1', '');

                        //console.log("baseURL:",baseURL)  
                   
                         dispatch({ type: surveyConstants.OPEN_EDIT_SURVEY, 
                            data: formInitialValues,
                            surveyImagePreview: formInitialValues.filePath,
                            thankImagePreview: formInitialValues.fileThankPath,

                            //surveyImagePreview: `${baseURL}/uploads/${formInitialValues.fileName}`,
                            //thankImagePreview: `${baseURL}/uploads/${formInitialValues.fileThankName}`,

                         })
                        
                    } else {
                        customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
                    }
                },
                error => {
                    customAlert(dispatch, 'error', i18n.t(defaultFailedText))
                }
            ).then(() => {
                loader(dispatch, false)
            })
    };
}

function getSubSurveyById(id) {
    return dispatch => {
        loader(dispatch, true)
        surveyServices.getSubSurveyById(id)
            .then(
                response => {
                    if (response.status) {
                        // let selectedProductList = [];
                        const subSurveyData = response.data
                        let formInitialValues = subSurveyData
                        
                   
                         dispatch({ type: surveyConstants.OPEN_EDIT_SUB_SURVEY, 
                            data: formInitialValues,

                         })

                        
                    } else {
                        customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
                    }
                },
                error => {
                    customAlert(dispatch, 'error', i18n.t(defaultFailedText))
                }
            ).then(() => {
                loader(dispatch, false)
            })
    };
}

function updateSurvey(params) {
    return dispatch => {
        loader(dispatch, true)
        surveyServices.updateSurvey(params)
            .then(
                response => {
                    if (response.status) {
                        dispatch({
                            type: surveyConstants.EDIT_SURVEY_SUCCESS
                        });
                        customAlert(dispatch, 'success', i18n.t('warning_messages.campaign_was_updated'));
                    } else {
                        
                            if (!response.unAlert) {
                                let responseMessage = response.message.toString()
                                if (responseMessage.includes('_')) {
                                    customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
                                } else {
                                    customAlert(dispatch, 'error', response.message.toString())
                                }
                            }
                        
                    }
                },
                error => {
                    customAlert(dispatch, 'error', i18n.t(defaultFailedText))
                }
            ).then(() => {
                loader(dispatch, false)
            })
    };
}

function updateSubSurvey(params) {
    return dispatch => {
        loader(dispatch, true)
        surveyServices.updateSubSurvey(params)
            .then(
                response => {
                    if (response.status) {
                        dispatch({
                            type: surveyConstants.EDIT_SUB_SURVEY_SUCCESS
                        });
                        customAlert(dispatch, 'success', i18n.t('warning_messages.campaign_was_updated'));

                    // Trigger the form or modal close after success
                    if (typeof this.closeForm === 'function') {
                        this.closeForm();  // Or whatever function closes the form/modal
                    }

                    } else {
                        
                            if (!response.unAlert) {
                                let responseMessage = response.message.toString()
                                if (responseMessage.includes('_')) {
                                    customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
                                } else {
                                    customAlert(dispatch, 'error', response.message.toString())
                                }
                            }
                        
                    }
                },
                error => {
                    customAlert(dispatch, 'error', i18n.t(defaultFailedText))
                }
            ).then(() => {
                loader(dispatch, false)
            })
    };
}

function deleteSubSurvey(params) {
    return dispatch => {
        loader(dispatch, true)
        return surveyServices.deleteSubSurvey(params)
            .then(
                response => {
                    if (response.status) {
                        
                        dispatch({ type: surveyConstants.DELETE_SUB_SURVEY_SUCCESS })
                        customAlert(dispatch, 'success', i18n.t('warning_messages.question_was_deleted'));
                    } else {
                            if (!response.unAlert) {
                                let responseMessage = response.message.toString()
                                if (responseMessage.includes('_')) {
                                    customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
                                } else {
                                    customAlert(dispatch, 'error', response.message.toString())
                                }
                            }
                        
                    }
                },
                error => {
                    customAlert(dispatch, 'error', i18n.t(defaultFailedText))
                }
            ).then(() => {
                loader(dispatch, false)
            })
    };
}
